import { render, staticRenderFns } from "./terBroEcharts.vue?vue&type=template&id=3f8b648d&scoped=true&"
import script from "./terBroEcharts.vue?vue&type=script&lang=js&"
export * from "./terBroEcharts.vue?vue&type=script&lang=js&"
import style0 from "./terBroEcharts.vue?vue&type=style&index=0&id=3f8b648d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b648d",
  null
  
)

export default component.exports